const userAdminRoutes = [
];


export default userAdminRoutes;
